module.exports = __webpack_public_path__ + "static/media/wallfinishes_gwp_60yd_n.8940e961.csv";